import {createApi} from '@reduxjs/toolkit/query/react'
import {network} from '../utils/network'
import {appSlice} from './app/appSlice'
import {store} from './store'

const axiosBaseQuery = async ({url, baseUrl, method, data, params, showError = true, paramsSerializer, ...rest}, {signal}) => {

  try {
    const result = await network.axios({
      url: baseUrl ? baseUrl : (process.env.REACT_APP_API_URI ? process.env.REACT_APP_API_URI : "/") + url,
      method,
      data,
      params,
      paramsSerializer,
      signal,
      ...rest
    })
    return {data: result.data}
  } catch (axiosError) {
    let err = axiosError

    if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
      return {error: {status: 'cancelled', data: null}};
    }

    if (err?.response?.data?.message && showError) {
      store.dispatch(appSlice.actions.addMessage({
        type: 'error',
        text: err?.response?.data?.message || err?.response?.data?.detail,
      }))
    }

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    }
  }
}

export const api = createApi({
  reducerPath: 'splitApi',
  baseQuery: axiosBaseQuery,
  tagTypes: [],
  endpoints: () => ({}),
})
